import { createFileRoute } from '@tanstack/react-router'
import { ScCompliancePage } from '@/features/support-coordination/compliance'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/compliance',
)({
  component: ScCompliancePage,
})
